var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("message message--" + _vm.type)},[(_vm.iconName)?_c('icon',{attrs:{"name":_vm.iconName,"width":"20","height":"20"}}):_vm._e(),_c('span',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }